import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import useLocales from '../hooks/useLocales';
import { allLangs, defaultLang } from '../config';

export default function LanguageRouter() {
  const { lang } = useParams();
  const { onChangeLang } = useLocales();
  const navigate = useNavigate();
  const langStorage = localStorage.getItem('i18nextLng');

  useEffect(() => {
    if (lang && allLangs.findIndex((x) => x.value === lang) !== -1) {
      if (lang !== langStorage) onChangeLang(lang);
    } else if (!lang) {
      navigate(defaultLang?.value);
    } else {
      navigate('/404');
    }
  }, [lang]);

  return <Outlet />;
}
